<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('preInvoice.pageTitle'),
          href: '/pre-invoices'
        },
        {
          text: $t('add_new'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <headerMenu @student-save-success="onSelectStudent" />
          <div class="two-column-container" ref="containerRef">
            <div class="right-container ts-p-3 ts-flex ts-flex-col ts-h-screen">
              <academicV2 ref="academic" v-model="model" :validate="errors" @level-change="clearDetail"
                @grade-change="clearDetail" />
              <div class="ts-px-2 ts-mt-4 ts-flex-1 ts-overflow-auto">
                <feeItemDetailV2 ref="item_detail" v-model="model" :validate="errors" />
              </div>
              <div class="ts-bg-gray-100 ts-rounded-md ts-p-4 ts-text-white ts-mt-4">
                <div class="row">
                  <div class="col-md-8">
                    <textarea v-model="model.remark" rows="2" max :placeholder="$t('paymentNotice.remark')"
                      class="form-control"></textarea>
                  </div>
                  <div class="col-md-4">
                    <div class="ts-border ts-rounded-md ts-bg-white ts-grid ts-grid-cols-2 ts-gap-2 ts-py-1">
                      <div class="ts-text-right">
                        <p class="ts-text-gray-700">
                          {{ $t('paymentNotice.totalAmount') }} :
                        </p>
                      </div>
                      <div>
                        <p class="ts-text-black">
                          <strong>{{
                            formatNumber(model.total_amount)
                          }}</strong>
                        </p>
                      </div>
                      <div class="ts-text-right">
                        <p class="ts-text-gray-700">
                          {{ $t('paymentNotice.previewPdfFile') }} :
                        </p>
                      </div>
                      <div class="ts-flex ts-space-x-2 ts-items-center">
                        <ts-checkbox v-model="model.preview" style="margin-top: -8px;" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ts-flex ts-justify-end ts-mt-2 ts-space-x-2">
                  <ts-button @click.prevent="$router.push({ name: 'pre-invoice' })">{{ $t('cancel') }}</ts-button>
                  <ts-button outline color="primary" @click="saveAddNew">{{
                    $t('save_add_new')
                  }}</ts-button>
                  <ts-button color="primary" @click="save">{{
                    $t('save')
                  }}</ts-button>
                </div>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-drawer :title="$t('paymentNotice.studentInfo')" :width="500" :visible="showStudentModel"
      :body-style="{ paddingBottom: '80px' }" :zIndex="1024" @close="onClose">
      <student-list-v2 ref="student_list" v-model="model" @selected="onSelectStudent" />
    </a-drawer>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import headerMenu from './components/header-menu.vue'
import {
  studentListV2,
  academicV2,
  feeItemDetailV2,
  PreviewPDF
} from './components'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'preInvoiceCreate',
  components: {
    headerMenu,
    studentListV2,
    academicV2,
    feeItemDetailV2
  },
  data() {
    return {
      model: {
        inv_id: 0,
        pre_inv_date: moment().format('DD-MM-YYYY'),
        student_id: null,
        level_id: null,
        acp_id: null,
        acps_id: null,
        ac_st_id: null,
        ac_term_id: null,
        total_amount: 0,
        remark: null,
        preview: true,
        year: null,
        semester: null,
        grade_id: null,
        payment_method_id: null,
        bank_id: null,
        inv_detail_list: [],
        is_new_student: '',
        discounted_amount: 0,
        grand_total:0

      },
      students: [],
      errors: new Errors(),
      leftWidth: 300,
      totalWidth: 0,
      resizing: false,
      startX: 0,
      startLeftWidth: 0
    }
  },
  computed: {
    ...mapState('paymentNoticeModule', ['loading', 'showStudentModel']),
    formatNumber: () => (number = 0) => {
      return new Intl.NumberFormat('en-IN', {
        maximumSignificantDigits: 3
      }).format(number)
    }
  },
  methods: {
    ...mapMutations('paymentNoticeModule', [
      'SET_LOADING',
      'HIDE_SHOW_STUDENT_MODEL',
      'SET_SELECTED_STUDENT'
    ]),
    async onSelectStudent(student) {
      this.SET_LOADING(true)
      this.HIDE_SHOW_STUDENT_MODEL(false)

      this.model.student_id = student.student_id
      this.model.acp_id = student.acp_id
      this.model.acps_id = student.acps_id
      this.model.level_id = student.level_id
        ? student.level_id
          .split(',')
          .map(Number)
          .at(-1)
        : null
      this.model.grade_id = null
      this.model.year = null
      this.model.semester = null

      await Promise.all([
        this.$refs.academic.fetchLevels(),
        this.$refs.academic.fetchGrades(),
        this.$refs.academic.fetchTerm(),
        this.$refs.academic.fetchStudyTime()
      ]).finally(() => this.SET_LOADING(false))

      this.model.ac_st_id = null
      this.model.ac_term_id = null
      this.model.inv_detail_list = []
    },
    save() {
      this.errors = new Errors()
      this.SET_LOADING(true)
      this.$store
        .dispatch('paymentNoticeModule/onSave', this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.clearInput()
          if (this.model.preview) {
            this.previewPdf(response.data.url)
          } else {
            this.pushBack()
          }
        })
        .catch(error => {
          this.$toasted.error(error.response.data.message)
          this.errors = new Errors(error.response.data.errors)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.SET_LOADING(true)
      this.$store
        .dispatch('paymentNoticeModule/onSave', this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.clearInput()
          if (this.model.preview) {
            this.previewPdf(response.data.url)
          }
        })
        .catch(error => {
          this.$toasted.error(error.response.data.message)
          this.errors = new Errors(error.response.data.errors)
        })
        .finally(() => {
          this.SET_LOADING(false)
        })
    },
    pushBack() {
      this.$router.push({ name: 'pre-invoice' })
    },
    previewPdf(url) {
      this.$modal.show(
        PreviewPDF,
        {
          url
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.clearInput
        }
      )
    },
    clearInput() {
      this.model.pre_inv_date = moment().format('DD-MM-YYYY')
      this.model.student_id = ''
      this.model.year = ''
      this.model.level_id = ''
      this.model.acp_id = ''
      this.model.acps_id = ''
      this.model.semester = ''
      this.model.grade_id = null
      this.model.total_amount = ''
      this.model.remark = ''
      this.model.inv_detail_list = []
      this.model.ac_st_id = null
      this.model.ac_term_id = null
      this.model.is_new_student = ''
      this.SET_SELECTED_STUDENT({})
      this.clearDetail()
    },
    clearDetail() {
      const detail = this.$refs.item_detail

      if (detail) {
        this.model.inv_detail_list = []
        detail.feeSetups = []
      }
    },
    onClose() {
      this.HIDE_SHOW_STUDENT_MODEL(false)
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearInput({})
    next()
  }
}
</script>

<style>
.two-column-container {
  display: flex;
  width: 100%;
  height: 80vh;
  position: relative;
}

.right-container {
  height: 100%;
  flex-grow: 1;
}
</style>
